import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { Location, LocationResponse } from './models/location';
import { BaseService } from './shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends BaseService {
  private locationsDataUrl = this.apiUrl + '/locations';

  addLocationData(location: Location) {
    return this.http.post<LocationResponse>(this.locationsDataUrl, location, this.httpOptions).pipe(
      tap((newLocationData: LocationResponse) => this.log(`added location: ${newLocationData}`)),
      catchError(this.handleError<LocationResponse>('addLocationData', <LocationResponse>{}))
    );
  }
}
